import React, { useState, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'layouts/supporter/Layout';
import SubmitButton from 'components/SubmitButton';
import SelectBox from 'components/SelectBox';
import { IconChevronLeft, IconClose } from 'components/Svg';
import sample1 from 'assets/common/images/sample1.jpg';
import sample2 from 'assets/common/images/sample2.jpg';
import sample3 from 'assets/common/images/sample3.jpg';

const SelectOptions = [
  { value: 'option1', label: '状況1' },
  { value: 'option2', label: '状況2' },
  { value: 'option3', label: '状況3' },
];

const Add: React.FC = () => {
  const navigate = useNavigate();
  const [notes, setNotes] = useState('');
  const [date, setDate] = useState(''); // 追加

  const request = {
    requestNo: '250831124201',
    username: '店舗A',
    supportername: '山田太郎',
    address: '〒178-0061 東京都練馬区大泉学園町',
    phone: '01234567890',
  };

  const images = [
    { label: 'トラブル発生場所', src: sample1 },
    { label: '現在の状況', src: sample2 },
    { label: '店舗外観', src: sample3 },
  ];

  const handleSubmit = () => {
    // submit logic
    alert('レポート報告書を作成しました。');
  };

  return (
    <Layout>
      <div className="p-4">
        {/* Header: 最上位階層のみtitleとicon */}
        <div className="flex items-center justify-between">
          <button className="p-2" onClick={() => navigate(-1)}>
            <IconChevronLeft />
          </button>
          <div className="flex flex-col items-center flex-1">
            <span className="text-lg font-medium text-gray-900">レスキュー作業報告</span>
          </div>
          <button className="p-2" onClick={() => navigate('/supporter')}>
            <IconClose />
          </button>
        </div>

        {/* Content */}
        <main className="flex-1 px-4 py-2 overflow-auto">
          <p className="my-4 text-sm text-gray-700">
            入力した内容は以下の通りです。<br />
            内容を確認後、利用規約に同意の上「送信する」ボタンを押してください。<br />
            送信後は担当者から折り返しの電話が来ますので、そのままお待ちください
          </p>
          {/* Request info */}
          <div className="text-base font-semibold text-gray-700">依頼内容</div>
          <div className="p-4 mt-2 text-sm text-gray-800 bg-white rounded-lg shadow">
            <dl className="grid grid-cols-1 gap-x-8 gap-y-4">
              <div>
                <dt className="mb-1 text-gray-500">レスキュー案件番号</dt>
                <dd className="font-semibold">{request.requestNo}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">店舗名</dt>
                <dd className="font-semibold">{request.username}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">担当者名</dt>
                <dd className="font-semibold">{request.supportername}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">訪問先住所</dt>
                <dd className="font-semibold">{request.address}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">訪問先電話番号</dt>
                <dd className="font-semibold">{request.phone}</dd>
              </div>
            </dl>
          </div>
          {/* Form fields */}
          <div className="mt-4 space-y-4 text-sm text-gray-800">
            <div className="mb-2 text-base font-semibold text-gray-700">レスキュー作業報告</div>
            <div>
              <label className="block mb-1 text-gray-500">対応日</label>
              <input
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
                className="w-full p-2 bg-white border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <SelectBox
                id="selectbox-sample1"
                options={SelectOptions}
                value=""
                label="状況"
                placeholder="状況を選択してください"
                className='p-2'
              />
            </div>
            {/* Notes */}
            <div className="mt-6">
              <label className="block mb-1 text-sm text-gray-500">対応内容</label>
              <textarea
                value={notes}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setNotes(e.target.value)}
                rows={4}
                className="w-full p-2 bg-white border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block mb-1 text-gray-500">次回の報告期日（有無）について</label>
              <input type="text" className="w-full p-2 bg-white border border-gray-300 rounded-md"/>
            </div>
            <div>
              <label className="block mb-1 text-gray-500">お見積り金額</label>
              <input type="text" className="w-full p-2 bg-white border border-gray-300 rounded-md"/>
            </div>
            {/* Images */}
            <div className="mt-6 space-y-4">
              <div className="mb-2 text-base font-semibold text-gray-700">状況写真</div>
              {images.map((img, i) => (
                <div key={i} className="">
                  <div className="mb-1 text-sm text-gray-500">{img.label}</div>
                  <div className="overflow-hidden bg-gray-100 rounded-md">
                    <img
                      src={img.src}
                      alt={img.label}
                      className="object-contain w-full h-auto max-h-80"
                      style={{ background: '#f3f4f6' }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>

        <div className="px-4 py-6 shadow-top">
          <div className="flex flex-col items-center mb-2 text-sm">
            <div className="flex justify-center w-1/5 space-x-4">
              <SubmitButton onClick={handleSubmit}>
                登録
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Add;